var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5",attrs:{"flat":""}},[_c('a',{attrs:{"href":_vm.resetPasswordUrl}},[_vm._v(" "+_vm._s(_vm.$t('Reset password'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }